import React, { memo } from "react";
import PageHeader from "ui/PageHeader/PageHeader";

const Dashboard = () => {
  return <PageHeader title={"Dashboard"} />;
};

export default memo(Dashboard);
